(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["holiday-catalog-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('holiday-catalog-guide')) {
 customElements.define('holiday-catalog-guide',class extends HTMLElement {
  connectedCallback(){
   if(this.bound)return;this.bound=true;
   this.dialog=this.querySelector('dialog');this.frame=this.querySelector('iframe');
   this.addEventListener('click',e=>{
    if(e.target.closest('[data-open]')){this.trigger=e.target.closest('[data-open]');if(this.frame.getAttribute('src')==='about:blank')this.frame.src=this.frame.dataset.src;this.dialog.showModal();}
    if(e.target.closest('[data-close]'))this.dialog.close();
    if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}
   });
   this.dialog.addEventListener('close',()=>{if(this.trigger?.isConnected)this.trigger.focus();});
  }
  disconnectedCallback(){if(this.dialog?.open)this.dialog.close();}
 });
}

  } catch(e) { console.error(e); }
})();
})();
